import React, { useState } from "react";
import ContentLoader from "react-content-loader";
import toast from "react-hot-toast";
import { IoMdCloseCircleOutline } from "react-icons/io";
import { deleteHoliday } from "../../api/services/hroneApi";
import { usePermissions } from "../../redux/slices/permissionsSlice";
import { FEATURE_CODES } from "../../util/featureCodes";
import PopupModal from "../PopupModal";
import { PrimaryButton, SecondaryButton } from "../../StyledCss/styledbtn";
import "./index.css";

const MyLoader = () => (
  <ContentLoader
    className="holidays-list-content-loader"
    backgroundColor="#E0E0E0"
  >
    <rect x="0" y="0" rx="5" ry="5" width="300" height="400" />
  </ContentLoader>
);

const apiStatusConstants = {
  initial: "INITIAL",
  success: "SUCCESS",
  failure: "FAILURE",
  inProgress: "IN_PROGRESS",
};

const HolidaysCard = ({ apiStatus, holidaysData, refreshHolidays }) => {
  const { hasPermission } = usePermissions();
  const [showHolidaysList, setShowHolidaysList] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [holidayToDelete, setHolidayToDelete] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);
  const formattedDate = (date) => {
    const parts = date.split("-");
    const month = parseInt(parts[1], 10);
    const day = parseInt(parts[0], 10);

    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    const textDay = formattedDay(day, monthNames[month - 1], month);

    return textDay;
  };

  const currentDay = new Date().getDate();
  const currentMonth = new Date().getMonth();
  const formattedDay = (day, monthName, month) => {
    if (currentDay === day && currentMonth + 1 === month) {
      return "Today";
    } else if (currentDay + 1 === day && currentMonth + 1 === month) {
      return "Tomorrow";
    } else {
      return day + getDaySuffix(day) + " " + monthName;
    }
  };

  const getDaySuffix = (day) => {
    if (day >= 11 && day <= 13) {
      return "th";
    }
    switch (day % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  };

  const onClickDeleteHoliday = (holiday) => {
    setHolidayToDelete(holiday);
    setIsDeleteModalOpen(true);
  };

  const confirmDeleteHoliday = async () => {
    try {
      setIsDeleting(true);
      const response = await deleteHoliday(holidayToDelete);
      if (response.status === 200) {
        refreshHolidays();
      }
    } catch (error) {
      toast.error("Failed to delete holiday. Please try again.");
    } finally {
      setIsDeleting(false);
      setIsDeleteModalOpen(false);
      setHolidayToDelete(null);
    }
  };

  const cancelDeleteHoliday = () => {
    setIsDeleteModalOpen(false);
    setHolidayToDelete(null);
  };

  const [showText, setShowText] = useState(false);

  const showOrHideHolidays = () => {
    setShowText(!showText);
    if (holidaysData.length >= 6) {
      setShowHolidaysList(!showHolidaysList);
    } else {
      setShowHolidaysList(false);
    }
  };

  const orgDetails = JSON.parse(localStorage.getItem("org"));
  const { primaryColor } = orgDetails;

  const renderHolidaysList = () => (
    <div className="events-container">
      <p className="birthday-Heading">Holiday's</p>
      {holidaysData.length > 0 ? (
        <>
          <ul
            style={{
              height: showHolidaysList ? "450px" : "258px",
            }}
            className="events-list"
          >
            {holidaysData.map((eachDay, index) => (
              <div className="holiday-display-card">
                <li key={index} className="holidays-card">
                  <p className="holiday-name">{eachDay.occasion}</p>
                  <p className="name-heading">{formattedDate(eachDay.date)}</p>
                </li>

                {hasPermission(FEATURE_CODES.DASHBOARD_HOLIDAY_DELETE) && (
                  <IoMdCloseCircleOutline
                    key={eachDay.date}
                    onClick={() => onClickDeleteHoliday(eachDay)}
                    className="holiday-delete-icon"
                  />
                )}
              </div>
            ))}
          </ul>
        </>
      ) : (
        <div
          style={{
            height: "274px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <p style={{ textAlign: "center" }}>No Holidays </p>
        </div>
      )}

      <div
        // onClick={() => setShowHolidaysList(!showHolidaysList)}
        onClick={showOrHideHolidays}
        className="container-bottom-section"
      >
        <p style={{ color: primaryColor }}>
          {showText ? "Show Less" : "See All Holiday's"}
        </p>
      </div>
    </div>
  );

  const DisplayHolidaysList = () => {
    switch (apiStatus) {
      case apiStatusConstants.success:
        return renderHolidaysList();
      case apiStatusConstants.failure:
        return <MyLoader />;
      case apiStatusConstants.inProgress:
        return <MyLoader />;
      default:
        return null;
    }
  };

  return (
    <div>
      {DisplayHolidaysList()}
      <div className="no-modal-mb">
        <PopupModal
          showModal={isDeleteModalOpen}
          modalName="Confirm Delete"
          closeBtn={cancelDeleteHoliday}
          marginBottom="0px"
        >
          <div>
            <p>
              Are you sure you want to delete the holiday &quot;{holidayToDelete?.occasion}&quot;?
            </p>
            <div
              style={{
                display: "flex",
                gap: "10px",
                justifyContent: "center",
                marginTop: "15px",
              }}
            >
              <SecondaryButton onClick={cancelDeleteHoliday}>Cancel</SecondaryButton>
              <PrimaryButton disabled={isDeleting} onClick={confirmDeleteHoliday}>
                {isDeleting ? "Deleting..." : "Delete"}
              </PrimaryButton>
            </div>
          </div>
        </PopupModal>
      </div>
    </div>
  );
};

export default HolidaysCard;
